import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ButtonIcon from "../../button";
import ListBox from "../custom-form/list-box.component";
import Translation from "../translation/translation.component";

export class CustomColumns extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.resetDefault=this.resetDefault.bind(this);
    this.state={
      show:false,
      clearData:false,
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
        selectedTwo: [],
        selectedCols: [],
        isSaving: false
    }
  }

  handleClose(){
    this.setState({
        show: false,
        isSaving: false
    });
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };

  resetDefault() {   
    this.setState({clearData:true});
  }

  
  resetClearData(item) {
    this.setState({clearData:item})
  }

    secondList = () => {
        var secondList = this.props.secondList ?? [];
        var selected = this.state.selected ?? [];
        return [
            ...secondList,
            ...selected
        ];
    }

    handleSelectedCols = (selectedCols) => {
        this.setState({
            selectedCols: selectedCols
        });
    }

    async saveSelectedCols() {
        const { saveAction, secondList } = this.props;
        const { selectedCols } = this.state;
        this.setState({
            isSaving: true
        });
        await saveAction(selectedCols.length > 0 ? selectedCols : secondList);
        this.handleClose();
    }
 
  render(){
    const {show,clearData,isSaving }=this.state;
    return(
      <>

       <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="gear" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Customize Column"/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container custom-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Customize Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListBox firstList={this.props.firstList} secondList={this.props.secondList} defaultList={this.props.defaultList} resetFilter={clearData} resetClearData={this.resetClearData.bind(this)} handleSelectedData={this.handleSelectedCols}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.resetDefault} disabled={isSaving}>
            <Translation translationKey="reset_default" />
          </Button>
          <Button variant="primary" onClick={()=> this.saveSelectedCols()} disabled={isSaving}>
            <Translation translationKey="call_save" />
          </Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
